import { useState, useEffect } from "react";

import Facade from "../components/containers/Facade";
import Footer from "../components/containers/Footer";
import { WhiteSpace, LineSeparator, Image, Grid, GridItem } from "../components/supports";
import ImageButton from "../components/buttons/ImageButton";
import ContentButton from "../components/buttons/ContentButton";


const LeaderboardsIndex = () =>{
    const galleryImageSize = 140;
    return(
        <div id="main_wrapper">
            <header>
                <h1></h1>
                <nav>
                </nav>
            </header>

            <div id="main_container">
         
            <WhiteSpace height="50"/>

            
                  
            </div>
            <div id="contents">
                <section>
                    <Facade bmg="/images/main-background.png" size="540px">
                    <WhiteSpace height="200"/>
                    <Image src="/images/crown.png" width="200"/>
                    <WhiteSpace height={"20"}/>
                    <div className="big-title-text">Leaderboards</div>
                    <WhiteSpace height="100"/>
                    <WhiteSpace height="50"/>
                </Facade>
                    <article className="article-center">
                        <div className="gallery">
                           
                          
                            <WhiteSpace height={"20"}/>
                           
                            <div className="title-text">Prove that you are the best against other players from over the world!</div>

                            <article className="article-center">
                                <div className="gallery">
                                  
                                    <WhiteSpace height="50"/>
                                    <div className="showroom-title">Available games</div>
                                    <WhiteSpace height="10"/>
                                    <LineSeparator width="500"/>
                                    <WhiteSpace height="5"/>
                                    <Grid templateColumns={"repeat(1,1fr)"}>
                                        <GridItem><ImageButton pathTarget="/5a/leaderboards" imgSrc="/images/5a.png" imgHeight={galleryImageSize}/></GridItem>
                                        {/*<GridItem><ImageButton pathTarget="/ignition/leaderboards" imgSrc="/images/nitrostream3.png" imgHeight={galleryImageSize}/></GridItem>*/}
                                        
                                    </Grid>
                                    <WhiteSpace height="50"/>
                                    <LineSeparator width="500"/>
                                    <WhiteSpace height="50"/>
                                </div>
                                
                          </article>

                            <WhiteSpace height={"100"}/>
                          
                        </div>
                    </article>
                </section>
            </div>
           
            <Footer/>
        </div>
    );
}

export default LeaderboardsIndex;
